import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type WorkoutOption = { id: string; name: string };

export const WorkoutSelect = ({
  loading,
  selectedWorkout,
  workoutOptions,
  onSelectWorkout,
}: {
  loading: boolean;
  selectedWorkout: WorkoutOption | null;
  workoutOptions: WorkoutOption[];
  onSelectWorkout: (workout: WorkoutOption | null) => void;
}) => {
  const { t } = useTranslation();
  return (
    <Autocomplete
      fullWidth
      getOptionLabel={(option) => option.name}
      value={selectedWorkout}
      disabled={loading || workoutOptions.length === 0}
      options={workoutOptions}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(_, value) => {
        onSelectWorkout(value);
      }}
      sx={{
        '.MuiTextField-root': {
          mt: 0,
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={loading ? t('loading') : t('selectWorkout')}
          inputProps={{ ...params.inputProps, 'aria-label': t('selectWorkout') }}
        />
      )}
    />
  );
};
